import { GET_ATTENDANCE_DASHBOARD_STATUS } from '../../modules/constants';

export const getAttendanceDashboardStatus = () => ({
    type: GET_ATTENDANCE_DASHBOARD_STATUS,
});
